import {
  GetDamagedInfoQueryResponseType,
  GetDamagedTypeQueryParamsType,
} from '@/common/queries/getDamagedType/getDamagedTypeQuery.type';
import { BASE_URL, fetchApi } from '@/config/axiosSetting';

export const getDamagedType = (
  param: GetDamagedTypeQueryParamsType,
): Promise<GetDamagedInfoQueryResponseType> =>
  fetchApi.get(`${BASE_URL}api/base_info/damaged/`, {
    params: {
      damaged_pk: param.damaged_pk,
    },
  });
